import { render } from "./CategoryCard.vue?vue&type=template&id=7700f300&lang=pug"
import script from "./CategoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__